import {getUserInfo} from '@/apis/login';
import {getFixedOrganizationKey, resolveLoginContext} from '@/apis/organizationContext';
import {confirmFixedOrganizationSession} from './fixed-organization-session';
import { getTrustedRedirectUri } from './redirect-uri';

export const checkUser = async (): Promise<boolean> => {
  const orgKey = getFixedOrganizationKey();
  try {
    const loginContext = orgKey ? await resolveLoginContext(orgKey) : null;

    // Fixed entries must never fall back to the default organization when the
    // server cannot confirm their target context. The page-level error gate will
    // render after this check returns.
    if (orgKey && !loginContext) {
      return true;
    }

    const res = await getUserInfo();
    if (res.code !== 200) {
      return true;
    }
    if (!res.headers || !res.headers['x-user-role'] || res.headers['x-user-role'] === 'tourist') {
      return true;
    }
    if (orgKey && loginContext) {
      if (!confirmFixedOrganizationSession(orgKey, res.data, loginContext)) {
        return true;
      }
    }
    const redirectUri = getTrustedRedirectUri();
    if (redirectUri) {
      window.location.href = redirectUri;
      return false;
    }
    const domain = window.location.href.includes('dauyan.net') ? '.dauyan.net' : '.dauyan.com';
    window.location.href = `https://ielts${domain}/`;
    return false;
  } catch {
    return true;
  }
};
